import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';
import { getCategoryName } from '@/utils/content';

interface ArticleHeaderProps {
  article: ArticleItem;
}

export default function ArticleHeader({ article }: ArticleHeaderProps) {
  return (
    <header>
      <div className="flex flex-wrap items-center gap-2.5">
        <Link
          to={`/category/${article.categorySlug}`}
          className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-300 transition-colors hover:bg-accent-500/25"
        >
          <i className="ri-price-tag-3-line"></i>
          {getCategoryName(article.categorySlug)}
        </Link>
        {article.isLive ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-950">
            <i className="ri-flashlight-fill"></i>
            今夜首发
          </span>
        ) : null}
        <span className="text-xs text-foreground-600">线索编号 {article.id.toUpperCase()}</span>
      </div>

      <h1 className="mt-5 font-heading text-2xl font-black leading-snug text-foreground-50 md:text-4xl">
        {article.title}
      </h1>

      <p className="mt-4 border-l-2 border-primary-500/60 pl-4 text-sm leading-relaxed text-foreground-400 md:text-base">
        {article.excerpt}
      </p>

      <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 border-y border-background-200/70 py-4 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-user-3-line text-primary-400"></i>
          {article.author}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-calendar-line text-primary-400"></i>
          <time>{article.date}</time>
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-timer-line text-primary-400"></i>
          阅读约 {article.readTime}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <i className="ri-fire-line text-accent-400"></i>
          {article.hot.toLocaleString()} 热度
        </span>
      </div>
    </header>
  );
}